import React, { memo } from "react";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { m } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../hooks/useLanguage";
import { buildBlogPath } from "../../utils/languageUtils";

const BlogSideImage = ({ data, animation }) => {
  const { t } = useTranslation(["blog"]);
  const { currentLang } = useLanguage();

  return (
    <div>
      {data.map((item, i) => {
        const postPath = buildBlogPath(currentLang, item.slug.current);
        return (
          <m.div key={i} className='blog-sideimage' {...animation}>
            <div className='blog-post-image rounded-lg'>
              <Link aria-label='link' to={postPath} className='w-full block'>
                <img height='auto' width='100%' alt={item.title} src={item.img} />
              </Link>
            </div>
            <div className='post-details'>
              <span className='blog-post-date !text-inaqgold'>{item.date}</span>
              <Link aria-label='link' to={postPath} className='blg-post-title !font-["Oxanium"] !font-bold !text-[32px] md:!text-[24px] sm:!text-[22px] !leading-[1.15] sm:!leading-[1.4]'>
                {item.title}
              </Link>
              <p className='line-clamp-4 !leading-[1.8] font-rubik'>{item.content}</p>
              {item.author && (
                <div className='blog-author mt-4'>
                  {item.author.image && <img height='' width='' className='blog-author-img' src={item.author.image} alt={item.author.name || ""} />}
                  <span>{item.author.name && <span>{t("author", "Autor")} <span className='blog-author-name !text-inaqgold'>{item.author.name}</span></span>}</span>
                </div>
              )}
            </div>
          </m.div>
        );
      })}
    </div>
  );
};

BlogSideImage.propTypes = {
  animation: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default memo(BlogSideImage);
